export const jwtTokenKey = 'usvid'
export const browserIdKey = 'bid'
export const browserIdKeyV2 = 'bidv2'
export const defaultSecret = 'UNSET_JWT_SECRET'

export const lineFriendUrl = 'https://line.me/R/ti/p/%40fas_official'
export const lineFriendRedirectPath = '/line/redirect/'
export const instagramUrl = 'https://www.instagram.com/fas/'
export const instagramSchemaUrl = 'instagram://user?username=fas'
export const instagramRedirectPath = '/instagram/redirect/'

export const twitterUrl = 'https://twitter.com/fas_skincare/'

export const postageFreeBillingAmountWithTaxLine = 5500
export const postage = 594

export const inquiryUrl =
  'mailto:info@fas-jp.com?subject=【FAS】公式ホームページより問い合わせ&body=お名前:%0D%0A電話番号:%0D%0Aご希望の返答方法:%0D%0A┗%20メールか電話、いずれかご記入ください%0D%0A配送番号:%0D%0A┗%20配送番号につきましては、注文に関する場合のお問い合わせの際にご記入ください'
